// Tarjeta Presente — planeta standalone: el cerebro del proyecto de pagos
// físicos (card-present). GBrain-style sobre brain_pages (mig 182):
// cuentas = páginas company · llamadas Gong · pipeline SF · decks · notas,
// con búsqueda híbrida, respuestas con citas y grafo navegable.

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PageTransition } from '@/components/PageTransition'
import { ResumenTab } from '@/components/tarjeta-presente/ResumenTab'
import { CerebroTab } from '@/components/tarjeta-presente/CerebroTab'
import { PreguntarTab } from '@/components/tarjeta-presente/PreguntarTab'
import { CapturaTab } from '@/components/tarjeta-presente/CapturaTab'
import { DecksTab } from '@/components/tarjeta-presente/DecksTab'
import { ChatTab } from '@/components/tarjeta-presente/ChatTab'
import { PageViewerSheet } from '@/components/tarjeta-presente/PageViewerSheet'

export function TarjetaPresente() {
  const navigate = useNavigate()
  const [tab, setTab] = useState('resumen')
  const [viewerSlug, setViewerSlug] = useState<string | null>(null)

  const openPage = (slug: string) => setViewerSlug(slug)

  return (
    <PageTransition>
      <div className="min-h-screen bg-background">
        <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-border/40 bg-background/80 px-6 backdrop-blur">
          <Button variant="ghost" size="sm" onClick={() => navigate('/')} aria-label="Volver al inicio">
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <span className="text-xl">💳</span>
          <div className="flex flex-col">
            <span className="font-heading text-base font-semibold leading-tight">Tarjeta Presente</span>
            <span className="text-xs text-muted-foreground leading-tight">
              Cerebro del proyecto · orquestación de pagos físicos
            </span>
          </div>
        </header>

        <main className="mx-auto max-w-6xl px-6 py-6">
          <Tabs value={tab} onValueChange={setTab}>
            <TabsList className="mb-5">
              <TabsTrigger value="resumen">Resumen</TabsTrigger>
              <TabsTrigger value="cerebro">Cerebro</TabsTrigger>
              <TabsTrigger value="preguntar">Preguntar</TabsTrigger>
              <TabsTrigger value="captura">Captura</TabsTrigger>
              <TabsTrigger value="decks">Decks</TabsTrigger>
              <TabsTrigger value="chat">Chat</TabsTrigger>
            </TabsList>
            {/* forceMount + hidden: switching tabs must NOT destroy in-progress
                state (a half-written note, an answer, the open chat thread) */}
            <TabsContent forceMount value="resumen" className="data-[state=inactive]:hidden"><ResumenTab onOpenPage={openPage} /></TabsContent>
            <TabsContent forceMount value="cerebro" className="data-[state=inactive]:hidden"><CerebroTab onOpenPage={openPage} /></TabsContent>
            <TabsContent forceMount value="preguntar" className="data-[state=inactive]:hidden"><PreguntarTab onOpenPage={openPage} /></TabsContent>
            <TabsContent forceMount value="captura" className="data-[state=inactive]:hidden"><CapturaTab onOpenPage={openPage} /></TabsContent>
            <TabsContent forceMount value="decks" className="data-[state=inactive]:hidden"><DecksTab onOpenPage={openPage} /></TabsContent>
            <TabsContent forceMount value="chat" className="data-[state=inactive]:hidden"><ChatTab /></TabsContent>
          </Tabs>
        </main>

        <PageViewerSheet
          slug={viewerSlug}
          onClose={() => setViewerSlug(null)}
          onOpenPage={openPage}
        />
      </div>
    </PageTransition>
  )
}
